import { Link } from "react-router-dom";

const quickLinks = [["/", "Home"], ["/about", "About Us"], ["/services", "Services"], ["/projects", "Projects"], ["/contact", "Contact"]];
const serviceLinks = [
  ["/services#transportation", "Aviation Consultancy & Support Services"],
  ["/services#cargo", "Aircraft Charter Services"],
  ["/services#spare-parts", "Critical Parts & Component Sourcing"],
  ["/services#cross-border", "Supply Chain Management"],
  ["/services#imports", "Digital Payment Systems"],
  ["/services#manufacturing", "Technical Support"],
];

export default function Footer() {
  return (
    <footer className="footer">
      <div className="svc-bg-image" style={{ backgroundImage: 'url("/assets/hero-bg-4.webp")' }} />
      <div className="svc-bg-overlay svc-bg-overlay--navy" />
      <div className="footer-container">
        <div className="footer-col">
          <h2 className="footer-logo">FinFlux</h2>
          <p>A trusted aviation partner delivering innovative aviation solutions, operational excellence, and strategic support across global markets, connecting businesses through safe, efficient, and reliable services.</p>
        </div>
        <div className="footer-col">
          <h3>Quick Links</h3>
          <ul>{quickLinks.map(([to, label]) => <li key={to}><Link to={to}>{label}</Link></li>)}</ul>
        </div>
        <div className="footer-col">
          <h3>Our Services</h3>
          <ul>{serviceLinks.map(([to, label]) => <li key={to}><Link to={to}>{label}</Link></li>)}</ul>
        </div>
      </div>
      <div className="footer-bottom"><p>&copy; {new Date().getFullYear()} Finflux Ventures &amp; Partners (Private) Limited. All Rights Reserved.</p></div>
    </footer>
  );
}
